import "./TreeViewTracker.css";
import { useState, useEffect } from "react";
// Import TreeView and TreeItem from the MUI X TreeView package
import { TreeView } from "@mui/x-tree-view/TreeView";
import { TreeItem } from "@mui/x-tree-view/TreeItem";

import { Get } from "../../../Common/WebRequest";
import {
  getStorageItem,
  getString,
  getValue,
  removeFromStorage,
  slice,
} from "../../../Common/Utility";

// Material UI icons
import { Place } from "@mui/icons-material";
import PlaceOutlinedIcon from "@mui/icons-material/PlaceOutlined";
import BranchIcon from "@mui/icons-material/AssuredWorkloadOutlined";
import PersonIcon from "@mui/icons-material/PersonOutlineSharp";
import CourseIcon from "@mui/icons-material/AutoStoriesOutlined";

function TreeViewTracker(props) {
  const [searchText, setSearchText] = useState("");
  const [foundElements, setFoundElements] = useState([]);
  const [reload, setReload] = useState(false);

  const [error, setError] = useState("");
  const [wait, setWait] = useState("");
  const [ordersData, setOrdersData] = useState([]);

  // Selected and expanded state now match the new props for MUI X TreeView
  const [selectedIds, setSelectedIds] = useState(["2"]);
  const [expandedIds, setExpandedIds] = useState(["01", "1-R", "2"]);

  const [firstTime, setFirstTime] = useState(true);
  const [defaultRegionId, setDefaultRegionId] = useState(1);
  const [defaultBranchId, setDefaultBranchId] = useState(2);
  const [newStudentAddedId, setNewStudentAddedId] = useState(0);

  useEffect(() => {
    (async () => {
      await LoadData();
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    (async () => {
      if (ordersData && ordersData.length > 0) {
        if (props.selectedStudentsToBeAddedToTree) {
          await handleAddStudent(ordersData);
        }
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.isSelectedStudent, props.selectedStudentsToBeAddedToTree.length]);

  useEffect(() => {
    (async () => {
      const nodeElement = document.getElementById(
        props.BranchId.toString() + "/" + props.StudentId.toString()
      );
      MoveScrollBarToNode(nodeElement);
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [newStudentAddedId]);

  useEffect(() => {
    (async () => {
      if (ordersData && ordersData.length > 0) {
        if (props.selectedCoursesToBeAddedToTree) {
          await handleAddCourse(ordersData);
        }
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.isSelectedCourse]);

  useEffect(() => {
    (async () => {
      if (props.CourseSaved) {
        await handleCourseSaved();
        setReload(!reload);
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.CourseSaved]);

  useEffect(() => {
    (async () => {
      if (props.CourseSaved) {
        const isFinish = await processStudents(ordersData); // if saved course => remove '*' from name
        if (isFinish) {
          let isRemoved = await removeEmptyStudent(ordersData);
          if (isRemoved) {
            await RemoveEmptyStudentFromStorage();
            handleOnStudentClick(props.RegionId, props.BranchId, 0);
            handleOnBranchClick(props.RegionId, props.BranchId);
          } else {
            handleOnStudentClick(
              props.RegionId,
              props.BranchId,
              props.StudentId
            );
            const queryId =
              props.BranchId + "/" + props.StudentId + "/" + props.CourseId;
            handleOnCourseClick(
              props.RegionId,
              props.BranchId,
              props.StudentId,
              props.CourseId,
              queryId
            );
            selectNextCourseNode(props.CourseId);
          }
        }
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.CourseSaved]);

  useEffect(() => {
    (async () => {
      if (!firstTime) return;

      const selectedNodes = await getSelectedNodeToExpand();
      if (selectedNodes.length > 0) {
        let regionIdValue = await getStorageItem("Tree", "regionId");
        let branchIdValue = await getStorageItem("Tree", "branchId");
        let studentIdValue = await getStorageItem("Tree", "studentId");
        let courseIdValue = await getStorageItem("Tree", "courseId");

        if (getValue(branchIdValue) > 0) {
          setSelectedIds([branchIdValue.toString()]);
          setExpandedIds(selectedNodes);
          setDefaultRegionId(regionIdValue);
          setDefaultBranchId(branchIdValue);
        }
        if (ordersData.length > 0 && getValue(props.courseId) === 0) {
          if (getValue(courseIdValue) > 0) {
            const queryId =
              branchIdValue + "/" + studentIdValue + "/" + courseIdValue;
            handleOnStudentClick(regionIdValue, branchIdValue, studentIdValue);
            handleNodeSelect(null, branchIdValue + "/" + studentIdValue);
            expandNode(branchIdValue + "/" + studentIdValue);
            handleNodeSelect(
              null,
              branchIdValue + "/" + studentIdValue + "/" + courseIdValue
            );
            expandNode(branchIdValue + "/" + studentIdValue);
            handleNodeSelect(
              null,
              branchIdValue + "/" + studentIdValue + "/" + courseIdValue
            );
            handleOnCourseClick(
              regionIdValue,
              branchIdValue,
              studentIdValue,
              courseIdValue,
              queryId
            );
          } else if (getValue(studentIdValue) > 0) {
            handleOnStudentClick(regionIdValue, branchIdValue, studentIdValue);
            handleNodeSelect(null, branchIdValue + "/" + studentIdValue);
            expandNode(branchIdValue + "/" + studentIdValue);
          } else if (getValue(branchIdValue) > 0) {
            handleOnBranchClick(regionIdValue, branchIdValue);
          } else if (getValue(branchIdValue) === 0) {
            handleOnBranchClick(defaultRegionId, defaultBranchId);
          }

          const nodeElement = document.getElementById(
            branchIdValue + "/" + getValue(studentIdValue)
          );
          if (nodeElement) {
            MoveScrollBarToNode(nodeElement);
          }
          if (nodeElement === null) {
            await RemoveEmptyStudentFromStorage();
            handleOnBranchClick(regionIdValue, branchIdValue);
          }
        }
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ordersData]);

  // -------------------------------- Data Loading --------------------------------
  async function LoadData() {
    setWait("Bitte warten..");
    console.log("Bitte warten..............");
    let res = await Get("TrackerStudent/Order");
    if (res.isSuccess) {
      setOrdersData(res.result.regions);
      setWait("");
    } else {
      setError(res.Status + "/" + res.Error);
    }
  }

  async function RemoveEmptyStudentFromStorage() {
    let regionIdValue = await getStorageItem("Tree", "regionId");
    let branchIdValue = await getStorageItem("Tree", "branchId");
    localStorage.setItem(
      "Tree",
      JSON.stringify({
        regionId: regionIdValue,
        branchId: branchIdValue,
        studentId: 0,
      })
    );
  }

  // -------------------------------- Search --------------------------------
  const handleSearchTextChange = (event) => {
    setFoundElements([]);
    setSearchText(event.target.value);
  };

  // get node to expand
  async function getSelectedNodeToExpand() {
    let node = ["01", "1-R", "0"];
    let regionIdValue = await getStorageItem("Tree", "regionId");
    let branchIdValue = await getStorageItem("Tree", "branchId");
    let studentIdValue = await getStorageItem("Tree", "studentId");
    let courseIdValue = await getStorageItem("Tree", "courseId");

    if (getValue(regionIdValue) > 0 && getValue(branchIdValue) > 0) {
      node = ["01", regionIdValue + "-R", branchIdValue.toString()];
    }
    if (
      getValue(regionIdValue) > 0 &&
      getValue(branchIdValue) > 0 &&
      getValue(studentIdValue) > 0
    ) {
      node = [
        "01",
        regionIdValue + "-R",
        branchIdValue.toString(),
        studentIdValue.toString(),
      ];
    }
    if (
      getValue(regionIdValue) > 0 &&
      getValue(branchIdValue) > 0 &&
      getValue(studentIdValue) > 0 &&
      getValue(courseIdValue) > 0
    ) {
      node = [
        "01",
        regionIdValue + "-R",
        branchIdValue.toString(),
        studentIdValue.toString(),
        courseIdValue.toString(),
      ];
    }
    return node;
  }

  // -------------------------------- Tree Click Handlers --------------------------------
  function handleOnRegionClick(regionId) {
    localStorage.setItem(
      "Tree",
      JSON.stringify({
        regionId: regionId,
      })
    );
    props.onRegionClick(regionId);
  }

  function handleOnBranchClick(regionId, branchId) {
    localStorage.setItem(
      "Tree",
      JSON.stringify({
        regionId: regionId,
        branchId: branchId,
      })
    );
    getNewStudentsByNodeBranch(regionId, branchId);
  }

  function handleOnStudentClick(regionId, branchId, studentId) {
    getNewStudentsByNodeBranch(regionId, branchId);
    getNewCoursesByNodeStudent(regionId, branchId, studentId);
    localStorage.setItem(
      "Tree",
      JSON.stringify({
        regionId: regionId,
        branchId: branchId,
        studentId: studentId,
      })
    );
  }

  function handleOnCourseClick(
    regionId,
    branchId,
    studentId,
    courseId,
    queryId,
    courseName = ""
  ) {
    getNewStudentsByNodeBranch(regionId, branchId);
    getNewCoursesByNodeStudent(regionId, branchId, studentId);
    props.onCourseClick(regionId, branchId, studentId, courseId, queryId);

    console.log("courseName: : " + courseName);
    // If name has '+' then it wasn't fully saved yet => do not store in local
    if (courseName.includes("+")) {
      courseId = 0;
      queryId = "";
    }
    localStorage.setItem(
      "Tree",
      JSON.stringify({
        regionId: regionId,
        branchId: branchId,
        studentId: studentId,
        courseId: courseId,
      })
    );
  }

  // fetch newly added or removed data
  function getNewStudentsByNodeBranch(regionId, branchId) {
    let regionIndex = getRegionIndexById(regionId);
    if (regionIndex < 0) return;

    const nodeBranch = ordersData[regionIndex].branches.find(
      (branch) => branch.id === branchId
    );
    let studentIds = [];
    if (nodeBranch) {
      studentIds = nodeBranch.students?.filter((student) =>
        student.studentName.includes("*")
      );
      studentIds = studentIds.map((student) => student.id);
      console.log("Old added students :", studentIds);
    }
    props.onBranchClick(regionId, branchId, studentIds);
    return studentIds;
  }

  function getNewCoursesByNodeStudent(regionId, branchId, studentId) {
    let regionIndex = getRegionIndexById(regionId);
    if (regionIndex < 0) return;

    let branchIndex = getBranchIndexByRegionIndexAndBranchId(
      regionIndex,
      branchId
    );
    if (branchIndex < 0) return;

    const nodeStudent = ordersData[regionIndex].branches[
      branchIndex
    ].students.find((student) => student.id === studentId);
    let courseIds = [];
    if (nodeStudent) {
      courseIds = nodeStudent.courses?.filter((course) =>
        course.courseName.startsWith("+")
      );
      courseIds = courseIds.map((course) => course.id);
      console.log("Old added courses :", courseIds);
    }
    props.onStudentClick(regionId, branchId, studentId, courseIds);
  }

  // display # of courses in a student's label
  function getStudentNameWithCoursesCount(studentName, courses) {
    if (getValue(courses?.length) > 0) {
      return studentName + " (" + courses.length + ")";
    }
    return studentName;
  }

  // -------------------------------- Add Student/Course --------------------------------
  async function handleAddStudent(ordersDataOrg) {
    console.log("handleAddStudent");
    console.log(
      "Selected Students --> into Tree ::: ",
      props.selectedStudentsToBeAddedToTree
    );

    if (
      !Array.isArray(props.selectedStudentsToBeAddedToTree) ||
      typeof props.selectedStudentsToBeAddedToTree === "undefined" ||
      props.BranchId === 0 ||
      !ordersData ||
      ordersData.length === 0
    ) {
      return;
    }

    const regionIndex = getRegionIndexById(props.RegionId);
    const branchIndex = getBranchIndexByRegionIndexAndBranchId(
      regionIndex,
      props.BranchId
    );
    if (regionIndex === -1 || branchIndex === -1) return;

    const newData = [...ordersDataOrg];
    // Students to remove (those with '*') that are no longer selected
    let studentsToBeRemoved = ordersData[regionIndex].branches[
      branchIndex
    ].students.filter((item) => item.studentName.includes("*"));
    studentsToBeRemoved = studentsToBeRemoved.filter(
      (student) =>
        !props.selectedStudentsToBeAddedToTree.find((s) => s.id === student.id)
    );

    // Add the newly selected students
    props.selectedStudentsToBeAddedToTree?.forEach((newStudent) => {
      const hasStudent = newData[regionIndex].branches[
        branchIndex
      ].students.some((student) => student.id === newStudent.id);
      if (!hasStudent && newStudent.branchId === props.BranchId) {
        newStudent.studentName =
          newStudent.studentName.replace(/\*/g, "").trim() + " *";
        newStudent.courses = [];
        newData[regionIndex].branches[branchIndex].students.push(newStudent);

        props.onStudentClick(props.RegionId, props.BranchId, newStudent.id);

        // Re-sort students by name
        newData[regionIndex].branches[branchIndex].students.sort((a, b) =>
          a.studentName.localeCompare(b.studentName)
        );

        setOrdersData(newData);
      }
    });

    console.log("ordersData --> Now::", ordersData);
    // Remove un-selected students from the tree
    newData[regionIndex].branches[branchIndex].students = newData[
      regionIndex
    ].branches[branchIndex].students.filter(
      (student) => !studentsToBeRemoved.find((s) => s.id === student.id)
    );

    setOrdersData(newData);

    // If no selected student, highlight default
    if (
      props.selectedStudentsToBeAddedToTree.length === 0 &&
      props.StudentId === 0
    ) {
      selectNextStudentNode(0);
    } else {
      if (props.selectedStudentsToBeAddedToTree.length === 0) {
        handleOnStudentClick(props.RegionId, props.BranchId, 0);
        return;
      }
      // Otherwise expand or highlight the newly added student
      const newStudentId =
        props.selectedStudentsToBeAddedToTree[
          props.selectedStudentsToBeAddedToTree.length - 1
        ].id;
      handleOnStudentClick(props.RegionId, props.BranchId, newStudentId);
      setNewStudentAddedId(newStudentId);
    }
  }

  async function handleAddCourse(ordersDataOrg) {
    if (
      !Array.isArray(props.selectedCoursesToBeAddedToTree) ||
      typeof props.selectedCoursesToBeAddedToTree === "undefined" ||
      props.BranchId === 0 ||
      props.studentId === 0 ||
      !ordersData ||
      ordersData.length === 0
    ) {
      return;
    }

    const regionIndex = getRegionIndexById(props.RegionId);
    if (regionIndex === -1) return;

    const branchIndex = getBranchIndexByRegionIndexAndBranchId(
      regionIndex,
      props.BranchId
    );
    if (branchIndex === -1) return;

    const studentIndex = getStudentIndexByIdRegionIndexAndBranchIndex(
      regionIndex,
      branchIndex
    );
    if (studentIndex === -1) return;

    const newData = [...ordersDataOrg];
    // find courses with '+' that are no longer selected
    let coursesToBeRemoved = newData[regionIndex].branches[
      branchIndex
    ].students[studentIndex].courses.filter((item) =>
      item.courseName.startsWith("+")
    );
    coursesToBeRemoved = coursesToBeRemoved.filter(
      (course) =>
        !props.selectedCoursesToBeAddedToTree.find(
          (c) => c.id === course.id && c.studentId === props.StudentId
        )
    );

    // Add newly selected courses
    props.selectedCoursesToBeAddedToTree?.forEach((newCourse) => {
      const hasCourse = newData[regionIndex].branches[branchIndex].students[
        studentIndex
      ].courses.some((course) => course.id === newCourse.id);

      if (!hasCourse && newCourse.studentId === props.StudentId) {
        newCourse.courseName = newCourse.courseName.replace(/\+/g, "").trim();
        newCourse.courseName = "+ " + newCourse.courseName;

        newData[regionIndex].branches[branchIndex].students[
          studentIndex
        ].courses.unshift(newCourse);
        setOrdersData(newData);
        expandNode(props.BranchId + "/" + props.StudentId);
      }
    });

    // Remove unselected courses from the tree
    newData[regionIndex].branches[branchIndex].students[studentIndex].courses =
      newData[regionIndex].branches[branchIndex].students[
        studentIndex
      ].courses.filter(
        (course) => !coursesToBeRemoved.find((c) => c.id === course.id)
      );

    let cid =
      newData[regionIndex].branches[branchIndex].students[studentIndex]
        .courses[0]?.id;
    if (typeof cid === "undefined" || coursesToBeRemoved.length === 0) cid = 0;

    setFirstTime(false);
    setOrdersData(newData);

    expandNode(props.BranchId + "/" + props.StudentId);
    selectNextCourseNode(props.selectedCoursesToBeAddedToTree[0]);

    const choosenCourses = props.selectedCoursesToBeAddedToTree;
    if (choosenCourses.length === 0) {
      selectNextStudentNode(props.StudentId);
      selectNextCourseNode(cid);
      props.onCoursesAdded(null);
    } else {
      selectNextStudentNode(props.StudentId);
      selectNextCourseNode(
        choosenCourses[choosenCourses.length - 1].id,
        choosenCourses[choosenCourses.length - 1].courseName
      );

      const nodeElement = document.getElementById(
        props.BranchId + "/" + props.StudentId
      );
      MoveScrollBarToNode(nodeElement);
    }
  }

  // -------------------------------- Handle Course Saved --------------------------------
  async function handleCourseSaved() {
    console.log("handleCourseSaved: true");
    var nextCourse = 0;
    // if removed from db, then remove it from tree
    //processStudents(ordersData);
    if (props.ResultCount === 0) {
      const region = ordersData.find((region) => region.id === props.RegionId);
      if (region) {
        const branch = region.branches.find(
          (branch) => branch.id === props.BranchId
        );
        if (branch) {
          const student = branch.students.find(
            (student) => student.id === props.StudentId
          );
          if (student?.courses) {
            if (student.courses.length > 1) {
              if (
                props.CourseId &&
                student.courses[student.courses.length - 1].id !==
                  props.CourseId
              ) {
                nextCourse = student.courses[student.courses.length - 1].id;
              } else {
                nextCourse = student.courses[0].id;
              }
            } else if (student.courses.length <= 1) {
              nextCourse = 0;
            } else {
              nextCourse = 0;
            }
            student.courses = student.courses.filter(
              (course) => course.id !== props.CourseId
            );
            // props.selectedCoursesToBeAddedToTree.unshift(course)

            let courseFound = null;
            if (props.selectedCoursesToBeAddedToTree)
              courseFound = props.selectedCoursesToBeAddedToTree.find(
                (course) => course.id === props.CourseId
              );
            if (
              typeof courseFound !== "undefined" &&
              props.selectedCoursesToBeAddedToTree
            ) {
              console.log("Course Found:", courseFound);
              var removedCourse = props.selectedCoursesToBeAddedToTree.filter(
                (course) => course.id !== courseFound.id
              );
              if (typeof removedCourse !== "undefined") {
                //props.selectedCoursesToBeAddedToTree = removedCourse;
                props.onCoursesAdded(removedCourse);
                //console.log("removedCourse :::: ", removedCourse);
                props.onCourseSaved(false);

                setOrdersData(ordersData);

                //setNewStudentAdded(0);
              }
            }
          }
        }
        selectNextCourseNode(nextCourse);

        return;
      }
    }
    nextCourse = 0;
    const student = ordersData
      .find((region) => region.id === props.RegionId)
      ?.branches.find((branch) => branch.id === props.BranchId)
      ?.students.find((student) => student.id === props.StudentId);

    if (student?.courses) {
      nextCourse = student.courses[0];
      const course = student.courses.find(
        (course) => course.id === props.CourseId
      );
      if (course && course.courseName.includes("+")) {
        course.courseName = course.courseName.replace(/\+/g, " ");

        setOrdersData(ordersData);

        handleOnCourseClick(
          props.RegionId,
          props.BranchId,
          props.StudentId,
          props.CourseId,
          course.courseName
        );

        //await handleRefresh();
      } else {
        await handleRefresh();
        // After refresh, reselect the course
        setTimeout(() => {
          selectNextCourseNode(props.CourseId);
        }, 100);
      }
    }
  }

  // -------------------------------- Data Cleanup Helpers --------------------------------
  async function processStudents(data) {
    const regionId = props.RegionId;
    const branchId = props.BranchId;
    const studentIdToProcess = props.StudentId;
    if (regionId === 0 || branchId === 0 || studentIdToProcess === 0) return;

    const region = data.find((r) => r.id === regionId);
    if (region) {
      const branch = region.branches.find((b) => b.id === branchId);
      if (branch) {
        const studentToProcess = branch.students.find(
          (student) => student.id === studentIdToProcess
        );
        if (studentToProcess) {
          const hasValidCourses =
            studentToProcess.courses &&
            studentToProcess.courses.some(
              (course) => course.courseName && !course.courseName.includes("+")
            );
          if (hasValidCourses) {
            studentToProcess.studentName = studentToProcess.studentName.replace(
              /\*/g,
              ""
            );
            setOrdersData(data);
          }
        }
      }
    }
    return true;
  }

  async function removeEmptyStudent(data) {
    let isFound = false;
    const regionId = props.RegionId;
    const branchId = props.BranchId;
    const studentIdToRemove = props.StudentId;
    if (regionId === 0 || branchId === 0 || studentIdToRemove === 0) return;

    const region = data.find((r) => r.id === regionId);
    if (region) {
      const branch = region.branches.find((b) => b.id === branchId);
      if (branch) {
        branch.students = branch.students.filter((student) => {
          if (student.id === studentIdToRemove) {
            if (!student.courses || student.courses.length === 0) {
              let allStudentsRemains = props.selectedStudentsToBeAddedToTree;
              const studentIdToRemove = props.StudentId;

              // Remove the empty student from the array
              allStudentsRemains = allStudentsRemains.filter(
                (student) => student.id !== studentIdToRemove
              );
              props.onStudentsAdded(allStudentsRemains);
              isFound = true;
            }
            return student.courses && student.courses.length > 0;
          }
          return true;
        });
      }
    }
    return isFound;
  }

  function getStudentIndexByIdRegionIndexAndBranchIndex(
    regionIndex,
    branchIndex
  ) {
    if (regionIndex === -1) return -1;
    return ordersData[regionIndex].branches[branchIndex].students.findIndex(
      (student) => student.id === getValue(props.StudentId)
    );
  }

  function getBranchIndexByRegionIndexAndBranchId(regionIndex, branchId) {
    if (regionIndex === -1) return -1;
    return ordersData[regionIndex].branches?.findIndex(
      (branch) => branch.id === getValue(branchId)
    );
  }

  function getRegionIndexById(regionId) {
    if (!Array.isArray(ordersData)) return -1;
    return ordersData.findIndex((region) => region.id === getValue(regionId));
  }

  // -------------------------------- TreeView State Handlers --------------------------------
  // (renamed for MUI X: onSelectedItemsChange & onExpandedItemsChange)
  const handleNodeSelect = (event, ids) => {
    console.log("selected id: ", ids);
    setSelectedIds(ids);
  };

  const handleNodeToggle = (event, nodeIds) => {
    setExpandedIds(nodeIds);
    if (nodeIds === "") {
      handleOnBranchClick(defaultRegionId, defaultBranchId);
    }
  };

  // -------------------------------- Node Selection Helpers --------------------------------
  function selectNextCourseNode(nextCourseId, courseName = "") {
    if (typeof nextCourseId === "undefined") return;
    if (nextCourseId > 0) {
      handleNodeSelect(
        null,
        props.BranchId + "/" + props.StudentId + "/" + nextCourseId
      );

      const queryId =
        props.BranchId + "/" + props.StudentId + "/" + nextCourseId;
      handleOnCourseClick(
        props.RegionId,
        props.BranchId,
        props.StudentId,
        nextCourseId,
        queryId,
        courseName
      );
      return queryId;
    } else {
      handleNodeSelect(null, props.BranchId + "/" + props.StudentId);
      handleOnStudentClick(props.RegionId, props.BranchId, props.StudentId);
    }
    return "";
  }

  function selectNextStudentNode(nextStudentId) {
    handleNodeSelect(null, props.BranchId + "/" + nextStudentId);
    handleOnStudentClick(props.RegionId, props.BranchId, nextStudentId);
    return props.BranchId + "/" + nextStudentId;
  }

  function expandNode(nodeId) {
    if (!expandedIds.includes(nodeId)) {
      setExpandedIds([...expandedIds, nodeId]);
      console.log("*** expandNode: ", nodeId);
    }
  }

  // -------------------------------- Refresh --------------------------------
  async function handleRefresh() {
    props.onCoursesAdded([]);
    props.onStudentsAdded([]);
    props.onCourseSaved();
    if (props.CourseId > 0) {
      handleOnCourseClick(
        props.RegionId,
        props.BranchId,
        props.StudentId,
        props.CourseId
      );
    } else if (props.StudentId > 0) {
      handleOnStudentClick(props.RegionId, props.BranchId, props.StudentId);
    } else {
      handleOnBranchClick(defaultRegionId, defaultBranchId);
    }
    setReload(!reload);
  }

  // -------------------------------- UI Helpers --------------------------------
  function hasExpiredCourse(regionId, branchId, studentId) {
    const region = ordersData.find((region) => region.id === regionId);
    if (region) {
      const branch = region.branches.find((branch) => branch.id === branchId);
      if (branch) {
        const student = branch.students.find(
          (student) => student.id === studentId
        );
        if (student?.courses) {
          const foundExpiredCourse = student.courses.some(
            (course) => course.isExpired === true
          );
          if (foundExpiredCourse) return true;
        }
      }
    }
    return false;
  }

  function hasFoundText(regionId, branchId, studentId, nodeId) {
    if (searchText === "" || searchText.length <= 1) return false;
    const region = ordersData.find((region) => region.id === regionId);
    if (region) {
      const branch = region.branches.find((branch) => branch.id === branchId);
      if (branch) {
        const student = branch.students.find(
          (student) =>
            student.id === studentId &&
            searchText.length >= 1 &&
            student.studentName.toLowerCase().includes(searchText.toLowerCase())
        );

        if (getString(student?.studentName) !== "") {
          const nodeElement = document.getElementById(nodeId);
          if (nodeElement) {
            foundElements.unshift(nodeElement);
            if (foundElements.length < 2) {
              MoveScrollBarToNode(nodeElement);
            }
          }
          return true;
        }
      }
    }
    return false;
  }

  async function MoveScrollBarToNode(nodeElement) {
    if (nodeElement === null) {
      await removeFromStorage("Tree");
      handleNodeSelect(null, "");
      handleOnCourseClick(0, 0, 0, 0, "");
      setSelectedIds([]);
      return;
    }
    if (nodeElement) {
      nodeElement.scrollIntoView({
        behavior: "instant",
        block: "start",
      });
      // Ensure no horizontal scroll offset remains
      const containerElement = nodeElement.closest(".MuiTreeView-root");
      if (containerElement) {
        containerElement.scrollLeft = 0;
      }
    }
  }

  // -------------------------------- Render --------------------------------
  return error.length > 0 ? (
    <>
      <div className="alert alert-danger" role="alert">
        {slice(error, 100, "...")}
      </div>
    </>
  ) : ordersData !== null ? (
    <div>
      <div className="TreeViewTrackerDiv">
        <div
          className="head"
          style={{
            width: "fit-content",
            alignContent: "baseline",
            color: "red",
            margin: "auto",
          }}
        >
          <strong>{wait}</strong>
          <div className="containerSearch">
            <button className="refreshButton" onClick={handleRefresh}>
              Refresh
            </button>
            <input
              autoFocus
              placeholder="Suche"
              className="searchInput"
              type="text"
              onChange={handleSearchTextChange}
            />
          </div>
        </div>

        {/* 
          Using MUI X's new props:
           - expandedItems / onExpandedItemsChange
           - selectedItems / onSelectedItemsChange
           - itemId instead of nodeId in TreeItem
        */}
        <TreeView
          id="TreeView"
          aria-label="Studenten"
          className="TreeView"
          expandedItems={expandedIds}
          onExpandedItemsChange={handleNodeToggle}
          selectedItems={selectedIds}
          onSelectedItemsChange={handleNodeSelect}
          sx={{
            margin: "auto",
            flexGrow: 2,
            width: "100%",
          }}
        >
          <TreeItem
            className="TreeItemStyle"
            itemId="01"
            label="Regionen"
            icon={<Place />}
          >
            {ordersData.map((region) => (
              <TreeItem
                className="TreeItemStyle"
                itemId={region.id + "-R"}
                id={region.id + ""}
                key={region.id + ""}
                label={`${region.name} (${region.branches.length})`}
                icon={<PlaceOutlinedIcon />}
                onClick={(e) => handleOnRegionClick(region.id)}
              >
                {region.branches.map((branch) => (
                  <TreeItem
                    className="TreeItemStyle"
                    itemId={branch.id + ""}
                    id={branch.id + ""}
                    key={branch.id + ""}
                    label={`${branch.name} (${branch.students.length})`}
                    icon={<BranchIcon />}
                    onClick={(e) => handleOnBranchClick(region.id, branch.id)}
                  >
                    {branch.students.map((student) => (
                      <TreeItem
                        className="TreeItemStyle"
                        id={branch.id + "/" + student.id}
                        key={branch.id + "/" + student.id}
                        itemId={branch.id + "/" + student.id}
                        label={
                          <span
                            style={{
                              color: hasExpiredCourse(
                                region.id,
                                branch.id,
                                student.id
                              )
                                ? "red"
                                : "inherit",
                              backgroundColor: hasFoundText(
                                region.id,
                                branch.id,
                                student.id,
                                branch.id + "/" + student.id
                              )
                                ? "yellow"
                                : student.studentName.includes("*")
                                ? "#adf802"
                                : "transparent",
                            }}
                          >
                            {getStudentNameWithCoursesCount(
                              student.studentName,
                              student.courses
                            )}
                          </span>
                        }
                        icon={<PersonIcon />}
                        onClick={(e) =>
                          handleOnStudentClick(region.id, branch.id, student.id)
                        }
                      >
                        {student.courses?.map((course) => (
                          <TreeItem
                            className="TreeItemStyle"
                            icon={<CourseIcon />}
                            id={branch.id + "/" + student.id + "/" + course.id}
                            key={branch.id + "/" + student.id + "/" + course.id}
                            itemId={
                              branch.id + "/" + student.id + "/" + course.id
                            }
                            label={
                              <span
                                style={{
                                  color: course.isExpired ? "red" : "inherit",
                                  backgroundColor: course.courseName.includes(
                                    "+"
                                  )
                                    ? "#e2fea1"
                                    : "transparent",
                                }}
                              >
                                {course.courseName}
                              </span>
                            }
                            onClick={(e) => {
                              handleOnCourseClick(
                                region.id,
                                branch.id,
                                student.id,
                                course.id,
                                branch.id + "/" + student.id + "/" + course.id,
                                course.courseName
                              );
                            }}
                          />
                        ))}
                      </TreeItem>
                    ))}
                  </TreeItem>
                ))}
              </TreeItem>
            ))}
          </TreeItem>
        </TreeView>
      </div>
    </div>
  ) : null;
}

export default TreeViewTracker;
